import { IonDate } from "../components/IonDate";

const CheckNotNull = Symbol('CheckNotNull');

class Broadcast {
    //from database
    public broadcastID: string = '';
    public poster: string = '';
    public title: string = '';
    public message: string = '';
    public start_datetime: Date | null;
    public end_datetime: Date | null;
    public action: string = '';
    public targeted_member_typeIDs: string[] = [];
    public targeted_member_user_types: string[] = [];
    public targeted_committee_typeIDs: string[] = [];
    public publish: boolean = true;
    public datetime_created: Date | null;

    //stored locally
    public read: boolean = false;
    public cleared: boolean = false;
    constructor(
        broadcastID: string,
        poster: string,
        title: string,
        message: string,
        start_datetime: string,
        end_datetime: string,
        action: string,
        targeted_member_typeIDs: string,
        targeted_member_user_types: string,
        targeted_committee_typeIDs: string,
        publish: string,
        datetime_created: string,
        read: boolean,
        cleared: boolean
    ) {
        this.broadcastID = this[CheckNotNull](broadcastID) ? broadcastID: '';
        this.poster = this[CheckNotNull](poster) ? poster: '';
        this.title = this[CheckNotNull](title) ? title: '';
        this.message = this[CheckNotNull](message) ? message: '';
        this.start_datetime = this[CheckNotNull](start_datetime) ? IonDate(start_datetime) : null;
        this.end_datetime = this[CheckNotNull](end_datetime) ? IonDate(end_datetime) : null;
        this.action = this[CheckNotNull](action) ? action : '';
        this.targeted_member_typeIDs = this[CheckNotNull](targeted_member_typeIDs) ? targeted_member_typeIDs.split(',') : [];
        this.targeted_member_user_types = this[CheckNotNull](targeted_member_user_types) ? targeted_member_user_types.split(',') : [];
        this.targeted_committee_typeIDs = this[CheckNotNull](targeted_committee_typeIDs) ? targeted_committee_typeIDs.split(',') : [];
        this.publish = this[CheckNotNull](publish) ? (publish == '1' ? true : false) : true;
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.read = read;
        this.cleared = cleared;
    }
    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0) 
            return true;
        else
            return false;
    }
}
export default Broadcast;